<script setup>
import {onMounted, ref, watch} from 'vue'
import {codePreview, formatDate} from '@/helper';
import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import Textarea from '@/components/forms/Textarea.vue';
import Select from '@/components/forms/Select.vue';
import ClientService from "@/services/ClientService";
import {useI18n} from 'vue-i18n';

const {t} = useI18n()
const props = defineProps({
  clientId: {type: String, required: true},
});

const isOpen = ref(true)
const emit = defineEmits(['confirm', 'cancel']);

const availableStrategies = ref([]);

const isLoading = ref(false);

/*const selectedStrategies = ref([]);*/

const form = ref({
  contractId: null,
  selectedStrategies: []
});

const clientContracts = ref([]);

const closeModalWith = (value) => {
  isOpen.value = false;
  setTimeout(() => {
    if (value === 'confirm') {
      emit('confirm', form.value);
    } else {
      emit('cancel');
    }
  }, 300);
}

onMounted(() => {
  //getAvailableInvestments();
  getContracts();
})

function openModal() {
  //getAvailableInvestments();
  isOpen.value = true
}

async function getAvailableInvestments() {
  isLoading.value = true;
  await ClientService.getAvailableInvestments(props.clientId, form.value.contractId)
    .then((response) => {
      availableStrategies.value = response;
      isLoading.value = false;
    })
    .catch((error) => {
      console.log(error);
    });
}

async function getContracts() {
  await ClientService.getClientContractsv2(props.clientId)
    .then((response) => {
      clientContracts.value = response;
      form.value.contractId = clientContracts.value.length ? Math.min(...clientContracts.value.map(contract => contract.id)) : null;
      if (form.value.contractId) {
        getAvailableInvestments();
      }
    })
    .catch((error) => {
      console.log(error);
    });
}
</script>

<template>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog as="div"  class="modal show d-block" style="z-index: 1055;">
      <div class="modal-backdrop fade show"></div>
      <div class="modal-dialog modal-dialog-centered modal-lg" style="z-index: 1055">
        <div class="modal-content">
          <DialogPanel class="modal-body p-4 rounded-lg shadow-lg">
            <div class="modal-header">
              <DialogTitle as="h3" class="modal-title">
                {{ t('createClientInvestmentsModal.add_investment') }}
              </DialogTitle>
              <i class="btn-close cursor-pointer" @click="closeModalWith('cancel')" aria-label="Close"></i>
            </div>
            <form @submit.prevent="closeModalWith('confirm')">
              <div class="modal-body">
                <div class="row">
                  <div class="col-12 mb-3 form-group">
                    <label for="contract" class="form-label">{{ t('createClientInvestmentsModal.choose_contract') }}</label>
                    <select v-model="form.contractId" class="form-select" id="contract" @change="getAvailableInvestments">
                      <option :key="index" v-for="(contract, index) in clientContracts" :value="contract.id">{{ contract.contract_type?.name }} ({{ contract.contract_number}})</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3 form-group">
                    <label for="strategy" class="form-label">{{ t('createClientInvestmentsModal.type') }}</label>
                    <div v-if="!form.contractId && !isLoading" class="text-muted">{{ t('createClientInvestmentsModal.select_contract') }}</div>
                    <div v-if="!form.contractId && isLoading" class="text-muted">{{ t('createClientInvestmentsModal.loading_data') }}</div>
                    <select v-if="form.contractId" v-model="form.selectedStrategies" class="form-select" id="strategy" multiple>
                      <option :key="index" v-for="(strategy, index) in availableStrategies" :value="strategy.id">{{strategy.strategy_name}}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="modal-footer">
                <button class="btn btn-link text-decoration-underline text-dark" @click="closeModalWith('cancel')">{{ t('createClientInvestmentsModal.cancel') }}</button>
                <button class="btn btn-primary btn-md" type="submit">{{ t('createClientInvestmentsModal.save') }}</button>
              </div>
            </form>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

